<template>
    <div>
        <SidebarDropdown>
            <template v-slot:button>
                <IconFileDescription
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                />
                {{ $tc('messages.activities', 2) }}
            </template>
            <template v-slot:items>
                <a
                    :href="route('students.activities.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.list') }}
                </a>
                <a
                    href="/s/activities/practice"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $t('messages.practice') }}
                </a>
                <a
                    href="/s/activities/practice_duels"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $tc('messages.duels', 2) }}
                </a>
                <a
                    :href="route('students.grades.index')"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    {{ $tc('messages.grades', 2) }}
                </a>
            </template>
        </SidebarDropdown>

        <div v-section:school_management>
            <a
                :href="route('students.fouls.index')"
                :class="version.anchorClasses"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <IconUserExclamation
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                />
                {{ $tc('messages.fouls', 2) }}
            </a>
        </div>

        <div v-if="$page.props.auth.is_gamification_active">
            <a
                :href="route('students.inventory.index')"
                :class="version.anchorClasses"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <IconBuildingWarehouse :class="version.iconClasses" class="w-6 h-6 text-gray-400" />
                {{ $tc('messages.inventory', 2) }}
            </a>

            <a
                :href="route('students.card_collections.index')"
                :class="version.anchorClasses"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <IconCards :class="version.iconClasses" class="w-6 h-6 text-gray-400" />
                {{ $tc('messages.card_collections', 2) }}
            </a>

            <a
                :href="route('students.rewards.index')"
                :class="version.anchorClasses"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <IconTrophy :class="version.iconClasses" class="w-6 h-6 text-gray-400" />
                {{ $tc('messages.gamification_rewards', 2) }}
            </a>

            <a
                :href="route('students.badges.index')"
                :class="version.anchorClasses"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <IconBadge class="w-6 h-6 text-gray-400" :class="version.iconClasses" />
                {{ $tc('messages.badges', 2) }}
            </a>

            <a
                :href="route('students.itineraries.index')"
                :class="version.anchorClasses"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <IconMap class="mr-3 w-6 h-6 text-gray-400" />
                {{ $tc('messages.itineraries', 2) }}
            </a>
        </div>

        <SidebarDropdown>
            <template v-slot:button>
                <IconDeviceGamepad2
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                />
                {{ $tc('messages.games', 2) }}
            </template>
            <template v-slot:items>
                <a
                    href="https://quinzet.vercel.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    Quinzet
                </a>
                <a
                    href="https://license-plate.vercel.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    Matrículas
                </a>
                <a
                    href="https://musicalnotes.vercel.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
                >
                    Notas musicales
                </a>
            </template>
        </SidebarDropdown>

        <div>
            <a
                href="/s/practice_dashboard"
                :class="version.anchorClasses"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <IconAbacus class="text-gray-400 w-6 h-6" :class="version.iconClasses" />
                {{ $t('messages.practice_dashboard') }}
            </a>
        </div>

        <div>
            <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSdNlV9kuIWjMjnPFtGJEw4NQ0AihKYTjwBvIQr70C9AZNMctg/viewform"
                target="_blank"
                :class="version.anchorClasses"
                rel="noopener noreferrer"
                class="mt-1 group flex items-center px-2 py-2 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
            >
                <IconHelpCircle
                    :class="version.iconClasses"
                    class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                />
                {{ $t('messages.suggestions_for_app') }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SidebarItemsForStudent',
};
</script>
<script setup>
import SidebarDropdown from '@/components/SidebarDropdown.vue';
import {
    IconAbacus,
    IconBadge,
    IconBuildingWarehouse,
    IconCards,
    IconDeviceGamepad2,
    IconFileDescription,
    IconHelpCircle,
    IconMap,
    IconTrophy,
    IconUserExclamation,
} from '@tabler/icons-vue';

const props = defineProps({
    sections: {
        type: Array,
        required: false,
        default: () => [],
    },
});

import { useAppSections } from '@/composables/useAppSections.js';

const { vSection } = useAppSections(props.sections);

const version = {
    iconClasses: 'mr-3',
    anchorClasses: 'text-sm leading-5',
};
</script>
